export enum OwnerTypes {
    Any = 1,
    My,
    ProvidedAsParam
}